import { nanoid } from 'nanoid';

// HEAD DATA
export const headData = {
  title: "Chris' Portfolio", // e.g: 'Name | Developer'
  lang: '', // e.g: en, es, fr, jp
  description: '', // e.g: Welcome to my website
};

// HERO DATA
export const heroData = {
  title: 'Hello, my name is ',
  name: 'Chris Pereira',
  subtitle: "I'm an aspiring Data Scientist and Machine Learning Engineer.",
  cta: '',
};

// ABOUT DATA, 2012 times person of the year
export const aboutData = {
  img: 'IMG_LI (1).png',
  paragraphOne:
    "Nominated as Time's Person of the Year in 2006 (seriously look it up!), I am in my final year of Software Engineering at Concordia University located in Montreal.",
  paragraphTwo:
    'I have a deep passion for learning new technologies and theories on machine learning and have an affinity to working with data. I also have some experience with web development through projects and hackathons. All of which can be found on my Github page.',
  paragraphThree: 'Click below to check out my resume!',
  resume: 'https://drive.google.com/file/d/1gM4Z8Pi2t1VPYtqpDzstTuTQLpZgU_u0/view?usp=sharing', // if no resume, the button will not show up
};

// PROJECTS DATA
export const projectsData = [
  {
    id: nanoid(),
    img: 'predict.PNG',
    title: 'Image Classifier',
    info: 'Image Classifier is a end-to-end machine learning project that detects the main ingredient in a dish of a user-uploaded photo.',
    info2: '',
    url: 'https://foodpredictorapp-srj7uwv6qq-uc.a.run.app',
    repo: 'https://github.com/cpereira00/Image-Classifier', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'fraud-detect.png',
    title: 'Credit Card Fraud Detection',
    info: 'Using credit card transaction data, I trained various machine learning models including a neural network, random forest and decision trees to detect fraudulent transactions.',
    info2:
      'Various undersampling and oversampling techniques like SMOTE were used to improve the working dataset as the amount of fraudulent transactions were disproportional to those that were non-fraudulent.',
    url: 'https://github.com/cpereira00/Credit-Card-Fraud-Detetection',
    repo: '', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'project.jpg',
    title: 'Housing Predictor',
    info: 'Housing Predictor is a Machine Learning project that aims to predict housing prices in San Antonio, Texas, through the use of multivariate linear regression.',
    info2:
      'Data was gathered and extracted by scraping multiple web pages from a realtor site using the beautifulsoup library. The data gathered was divided into a 70/30 train/test split and using the scikit-learn library, trained the multivariate linear regression model and used the test set to predict the housing prices.',
    url: 'https://github.com/cpereira00/HousingPredictor',
    repo: '', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'cert.PNG',
    title: 'Machine Learning Assignments',
    info: 'A list of ML assignments implementing various machine learning algorithms in MATLAB. ',
    info2:
      'This includes multi-class classification, neural networks, Support Vector machines and K-mean clustering to name a few.',
    url: 'https://github.com/cpereira00/Machine-Learning-Assignments', // remove
    repo: '', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'task-mana.PNG',
    title: 'Task Manager',
    info: 'TaskManager is a web application that allows users to create, delete and set reminders for themselves on their upcoming tasks all while being stored through JSON server.',
    info2:
      'The projects implements core fundamentals of React including component States, Props and Hooks and uses a fake REST API in JSON server for POST, PUT and DELETE requests.',
    url: 'https://github.com/cpereira00/Task-Manager',
    repo: '', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'audiobook.jpg',
    title: 'PDF to Audiobook',
    info: "This projects turns your boring PDFs into an audiobook usings python's text-to-speech and PDF file-reader libraries.",
    info2:
      "The purpose is to create an automation program that allows users to listen to their PDF's while reading as it is scientifically proven to increase memory retention.",
    url: 'https://github.com/cpereira00/PDFtoAudiobookProject',
    repo: '', // if no repo, the button will not show up
  },
  // {
  //   id: nanoid(),
  //   img: 'project.jpg',
  //   title: '',
  //   info: '',
  //   info2: '',
  //   url: '',
  //   repo: 'https://github.com/cobidev/react-simplefolio', // if no repo, the button will not show up
  // },
];

// CONTACT DATA
export const contactData = {
  cta: 'Would you like to connect with me?',
  btn: 'Email me!',
  email: 'c_reira@live.concordia.ca',
};

// FOOTER DATA
export const footerData = {
  networks: [
    {
      id: nanoid(),
      name: 'github',
      url: 'https://github.com/cpereira00',
    },
    {
      id: nanoid(),
      name: 'linkedin',
      url: 'https://www.linkedin.com/in/christophermpereira/',
    },
    {
      id: nanoid(),
      name: 'trophy',
      url: 'https://www.kaggle.com/conucp3',
    },
  ],
};

// Github start/fork buttons
export const githubButtons = {
  isEnabled: false, // set to false to disable the GitHub stars/fork buttons
};
